import React, { FC } from "react";
import Filters from "src/share/components/Filters/Filters";
import AgencyFilter from "src/share/components/Filters/inputs/AgencyFilter";
import StatusFilter from "src/share/components/Filters/inputs/StatusFilter";
import CaseTypeFilter from "src/share/components/Filters/inputs/CaseTypeFilter";
import { AppliedFilters, FilterType } from "src/share/components/Filters/types";
import {
  capitalize,
  timestampToDateTimeStringShort,
} from "src/share/utils/utils";
import DateRangeFilter from "src/share/components/Filters/inputs/DateRangeFilter";

type Props = {
  onFiltersApply: (filters) => void;
};

const initialFilters: AppliedFilters = {
  [FilterType.AGENCY]: {
    currentValue: null,
    icon: "fa fa-building-o",
    defaultValue: "ALL",
    formatter: (agency): string => (agency === "ALL" ? "All Agencies" : agency),
  },
  [FilterType.STATUS]: {
    defaultValue: "ALL",
    currentValue: null,
    icon: "fa fa-vcard-o",
    formatter: (status): string => `${capitalize(status)} Cases`,
  },
  [FilterType.CASE_TYPE]: {
    currentValue: null,
    icon: "fa fa-list-ul",
  },
  [FilterType.DATE_RANGE]: {
    currentValue: null,
    icon: "fa fa-calendar",
    formatter: (value: { startDate: number; endDate: number }): string =>
      `${timestampToDateTimeStringShort(value.startDate)}
      - ${timestampToDateTimeStringShort(value.endDate)}`,
  },
};

const StatsFilters: FC<Props> = ({ onFiltersApply }) => {
  return (
    <Filters filters={initialFilters} onFiltersApply={onFiltersApply}>
      <AgencyFilter />
      <StatusFilter />
      <CaseTypeFilter />
      <DateRangeFilter />
    </Filters>
  );
};

export default React.memo(StatsFilters);
